/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cart } from './Cart';
import {
    CartFromJSON,
    CartFromJSONTyped,
    CartToJSON,
} from './Cart';

/**
 * 
 * @export
 * @interface CreateCart201ResponseAllOfData
 */
export interface CreateCart201ResponseAllOfData {
    /**
     * 
     * @type {Cart}
     * @memberof CreateCart201ResponseAllOfData
     */
    cart: Cart;
}

/**
 * Check if a given object implements the CreateCart201ResponseAllOfData interface.
 */
export function instanceOfCreateCart201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cart" in value;

    return isInstance;
}

export function CreateCart201ResponseAllOfDataFromJSON(json: any): CreateCart201ResponseAllOfData {
    return CreateCart201ResponseAllOfDataFromJSONTyped(json, false);
}

export function CreateCart201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCart201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cart': CartFromJSON(json['cart']),
    };
}

export function CreateCart201ResponseAllOfDataToJSON(value?: CreateCart201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cart': CartToJSON(value.cart),
    };
}

